// project-imports
import { APP_DEFAULT_PATH } from 'config';

// ==============================|| RETURN TO ||============================== //

/** Routes a session must never bounce back into: doing so loops. */
const PUBLIC_PATHS = ['/login', '/auth/callback', '/auth/step-up/callback'];

/**
 * The pages where a sign-in or step-up is being completed. The session is created by the callback request
 * itself, so nothing may probe `/v1/me` (or refresh) there.
 */
export const isOAuthCallbackPath = (pathname: string): boolean => pathname === '/auth/callback' || pathname === '/auth/step-up/callback';

export const isPublicPath = (pathname: string): boolean =>
  PUBLIC_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));

/**
 * Accepts only same-site paths.
 *
 * `returnTo` travels through the query string and back out of the API, so anything that is not a
 * plain absolute path (`https://...`, `//host`, a backslash after the slash, control characters) falls
 * back to the home page rather than being followed.
 */
export const safeReturnTo = (value: string | null | undefined): string => {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) {
    return APP_DEFAULT_PATH;
  }

  if (value.split('').some((char) => char.charCodeAt(0) < 32)) {
    return APP_DEFAULT_PATH;
  }

  if (isPublicPath(value)) {
    return APP_DEFAULT_PATH;
  }

  return value;
};
